export const blockIconsCommunicationContacts = (
	<span className='material-symbols-outlined'>contacts</span>
);
